import { render, staticRenderFns } from "./TaxManage.vue?vue&type=template&id=206111fc&scoped=true"
import script from "./TaxManage.vue?vue&type=script&lang=js"
export * from "./TaxManage.vue?vue&type=script&lang=js"
import style0 from "./TaxManage.vue?vue&type=style&index=0&id=206111fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206111fc",
  null
  
)

export default component.exports